// Routa launches in Metro Vancouver, BC. The platform is architected to
// support additional Canadian cities/regions over time — this list simply
// seeds the current coverage area and is not a hard limit on the data model.
export const REGIONS = [
  "Downtown Vancouver", "Burnaby", "Richmond", "Surrey", "North Vancouver",
  "Coquitlam", "Langley", "Delta", "West Vancouver", "New Westminster",
];

// Backwards-compatible alias (older imports referenced ONTARIO_REGIONS).
export const ONTARIO_REGIONS = REGIONS;

export const LICENCE_CLASSES = ["Class 5", "Class 4", "Class 1", "Class 3"];

export const VEHICLE_TYPES = ["Cargo van", "Minivan", "Box truck", "Sprinter", "Sedan", "Pickup"];

export const REGION_COORDS = {
  "Downtown Vancouver": [49.2827, -123.1207],
  Burnaby: [49.2488, -122.9805],
  Richmond: [49.1666, -123.1336],
  Surrey: [49.1913, -122.849],
  "North Vancouver": [49.32, -123.0724],
  Coquitlam: [49.2838, -122.7932],
  Langley: [49.1044, -122.66],
  Delta: [49.0847, -123.0587],
  "West Vancouver": [49.3286, -123.16],
  "New Westminster": [49.2057, -122.911],
};

export const VANCOUVER_CENTER = [49.2827, -123.1207];

export function jitterCoords(region) {
  const base = REGION_COORDS[region] || VANCOUVER_CENTER;
  return { lat: base[0] + (Math.random() - 0.5) * 0.05, lng: base[1] + (Math.random() - 0.5) * 0.05 };
}

export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    price: 299,
    tagline: "Everything a growing store needs to start delivering.",
    popular: false,
    features: [
      "Core delivery management",
      "Driver management",
      "Order dashboard",
      "Customer tracking & notifications",
      "Limited same-hour delivery",
      "Basic analytics",
    ],
    excluded: ["No POS integration"],
  },
  {
    id: "growth",
    name: "Growth",
    price: 499,
    tagline: "For busy operations that need speed and automation.",
    popular: true,
    features: [
      "Everything in Starter",
      "Same-hour delivery",
      "POS integration",
      "Automated dispatch",
      "Advanced routing",
      "Advanced analytics",
      "Priority support",
    ],
    excluded: [],
  },
  {
    id: "scale",
    name: "Scale",
    price: 799,
    tagline: "Multi-location, high-volume delivery operations.",
    popular: false,
    features: [
      "Everything in Growth",
      "Multi-location support",
      "Advanced integrations / API",
      "Custom workflows",
      "Priority support",
      "Higher-volume operations",
    ],
    excluded: [],
  },
];

export const PLAN_BY_ID = Object.fromEntries(PLANS.map((p) => [p.id, p]));
